import {faCog, faFileInvoice, faLifeRing, faProjectDiagram, faStar, faTasks, faUser} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {observer} from 'mobx-react-lite';
import * as React from 'react';
import {FC} from 'react';
import {NavLink} from 'react-router-dom';

import {mainState} from '../AppMainState';
import {AppRoutes} from '../routing/AppRoutes';

export const Bottombar: FC = observer(() => {
    return <nav
        data-tut="bottombar"
        className="bg-m-gray-1 xl:hidden block fixed inset-x-0 bottom-0 z-10 w-full"
        id="bottombar">
        <ul className="flex">
            <li className="w-full">
                <NavLink
                    className="flex h-10 items-center justify-center w-full"
                    to={AppRoutes.Projects}
                >
                    <FontAwesomeIcon className="fill-current" icon={faProjectDiagram}/>
                    <span className="hidden sm:inline ml-4 bottombar-label">Projects</span>
                </NavLink>
            </li>
            {/*<li className='w-full'>
                <NavLink
                    activeClassName='font-medium text-m-green'
                    className='flex h-10 items-center justify-center w-full'
                    to={AppRoutes.Dashboard}
                >
                    <FontAwesomeIcon className='fill-current' icon={faHome} />
                    <span className='hidden sm:inline ml-4 bottombar-label'>Dashboard</span>
                </NavLink>
            </li>*/}
            <li className="w-full">
                <NavLink
                    className="flex h-10 items-center justify-center w-full"
                    to={AppRoutes.Starred}
                >
                    <div className="flex items-center">
                        <FontAwesomeIcon className="fill-current" icon={faStar}/>
                        <span className="hidden sm:inline ml-4 bottombar-label">Starred</span>
                        <span className="badge ml-4">{mainState.currentUser?.starred}</span>
                    </div>
                </NavLink>
            </li>
            <li className="w-full">
                <NavLink
                    className="flex h-10 items-center justify-center w-full"
                    to={AppRoutes.Assigned}
                >
                    <div className="flex items-center">
                        <FontAwesomeIcon className="fill-current" icon={faTasks}/>
                        <span className="hidden sm:inline ml-4 bottombar-label">Assigned</span>
                        <span className="badge ml-4">{mainState.currentUser?.assigned}</span>
                    </div>
                </NavLink>
            </li>
            <li className="w-full">
                <NavLink
                    className="flex h-10 items-center justify-center w-full"
                    to={AppRoutes.Settings}
                >
                    <div className="flex items-center">
                        <FontAwesomeIcon className="fill-current" icon={faCog}/>
                        <span className="hidden sm:inline ml-4 bottombar-label">Settings</span>
                    </div>
                </NavLink>
            </li>
            <li className="w-full">
                <NavLink
                    className="flex h-10 items-center justify-center w-full"
                    to={AppRoutes.Payments}
                >
                    <div className="flex items-center">
                        <FontAwesomeIcon className="fill-current" icon={faFileInvoice}/>
                        <span className="hidden sm:inline ml-4 bottombar-label">Billing</span>
                    </div>
                </NavLink>
            </li>
            <li className="w-full">
                <NavLink
                    className="flex h-10 items-center justify-center w-full"
                    to={AppRoutes.UserAccount}
                >
                    <div className="flex items-center">
                        <FontAwesomeIcon className="fill-current" icon={faUser}/>
                        <span className="hidden sm:inline ml-4 bottombar-label">Account</span>
                    </div>
                </NavLink>
            </li>
            <li className="w-full">
                <NavLink
                    id="helpbutton"
                    data-tut="helpbutton"
                    className="flex h-10 items-center justify-center w-full"
                    to={AppRoutes.ReportProblem}
                    onClick={(e) => {
                        e.preventDefault();
                        mainState.reportProblem();
                    }}
                >
                    <div className="flex items-center">
                        <FontAwesomeIcon className="fill-current" icon={faLifeRing}/>
                        <span className="hidden sm:inline ml-4 bottombar-label">Help</span>
                    </div>
                </NavLink>
            </li>
        </ul>
    </nav>;
});
